import React from 'react';
import {MasterLayout} from 'components/layouts';
import {MyBusinessPostDemandContainer} from 'components/my-business';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';

class MyBusinessPostDemandPage extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.MyBusinessPostDemandPage;
  }

  render() {
    return (
      <MasterLayout>
        <MyBusinessPostDemandContainer/>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessPostDemandPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessPostDemandPage.jsx